import { ENDPOINT } from '~/constants/endpoints';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { zodSavedFilterListResponseSchema } from '../validations';

import {
  type QuerySavedFiltersResponse,
  type SavedFiltersQueryParams,
} from './types';

/**
 * Fetches saved filters for a backend saved-filter type.
 *
 * @param queryParams - Saved-filter list query parameters.
 * @param options - Optional ky request options (e.g., abort signal).
 * @returns The saved-filter list response.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/User/operation/list_saved_filters_user_saved_filters_get
 */
export const fetchSavedFilters = async (
  queryParams: SavedFiltersQueryParams,
  options?: KyRequestOptions,
): Promise<QuerySavedFiltersResponse> => {
  const response = await vestigasApi
    .get(ENDPOINT.USER.SAVED_FILTERS(), {
      ...options,
      searchParams: queryParams,
    })
    .json<QuerySavedFiltersResponse>();

  const validated = zodSavedFilterListResponseSchema.safeParse(response);

  if (!validated.success) {
    console.warn(
      '[fetchSavedFilters] Response validation failed',
      validated.error,
    );
    return response;
  }

  return validated.data;
};
